import React, { Component } from 'react';
import cookie from 'react-cookies';
import axios from 'axios';
import './RACorpInfoBox.css';
import Config from '../Configs/criteria.json';

export default class RACorpInfoBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ric: this.props.ric,
            news: [],
            subtype: this.props.type
        }
    }
    getData = () => {
        axios.get("data/detail", {
            params: {
                ric: this.props.ric,
                type: 2,
                subtype: this.state.subtype,
                fid: 0,
                token: this.props.token
            }
        })
        .then(
            (result) => {
                if (result.data) {
                    this.setState({
                        news: result.data
                    })
                } else {
                    this.setState({
                        news: {}
                    })
                }
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
            }
        )
    }
    genDataRow = () => {
        let result = [];
        if (this.props.type==="0") {
            let cnt = 0;
            if (this.state.news.newsData) {
                for (let i=0; i<this.state.news.newsData.length; i++) {
                    let content = [];
                    let d = new Date(this.state.news.newsData[i].datetime);
                    content.push(<div className="newstime">{ d.toLocaleString("en-us", {month: '2-digit'}) + '/' + d.toLocaleString("en-us", {day: '2-digit'}) + ' ' + d.toLocaleString("en-GB", {hour: '2-digit', minute: '2-digit'})}</div>);
                    content.push(<div className="headline hyperlink">{this.state.news.newsData[i].headline}</div>);
                    result.push(<div className="stocknews">{content}</div>);
                    if (++cnt===4) break;
                }
            }
            if (cnt===0) {
                result.push(<div className="nonewsmsgbox">現在ニュースはありません。</div>);
            }
        } else if (this.props.type==="1") {
            result.push(<div className={this.state.news.biz_summary?"bizsummary":"bizsummaryempty"} onClick={this.state.news.biz_summary?this.handlePopup:null}>{this.state.news.biz_summary}</div>)
        }
        return result;
    }
    componentDidMount() {
        this.getData();
    }
    componentDidUpdate() {
        if ((this.state.ric!=="" && this.props.ric!==this.state.ric) || (this.state.subtype!==this.props.type)) {
            this.setState({ ric: this.props.ric, subtype: this.props.type }, () => { this.getData(); })
        }
    }
    handleAddTo = (code,exchangeCode,rexchangeCode) => (e) => {
        let url = this.props.appId==="Hyper"?Config.hyperdomain+"/5907/"+rexchangeCode+"/"+code : Config.domain+"/ETGate/?_ControlID=WPLETpfR001Control&_PageID=WPLETpfR001Eins13&_DataStoreID=DSWPLETpfR001Control&getFlg=on&_ActionID=viewPf&src_web_sec_code=" + code + "&src_sec_id=ST&src_market_id="+rexchangeCode+"&link_url=%2FETGate%2F%3F_ControlID%3DWPLETsqR001Control%26amp%3B_DataStoreID%3DDSWPLETsqR001Control%26amp%3B_PageID%3DWPLETsqR001Sdtl10%26amp%3BgetFlg%3Don%26amp%3B_ActionID%3DDefaultAID%26amp%3Bi_stock_sec%3D4307%26amp%3Bcat1%3Ddomestic%26amp%3Bcat2%3Dinfo%26amp%3Bsec_code%3D4307%26amp%3Bexchange_code%3D"+exchangeCode+"%26amp%3Bi_exchange_code%3DJPN&OutSide=on";
        window.open(url, this.props.appId==="Hyper"?"_self":"_blank"); 
    }
    handlePopup = (section) =>{
        this.props.handleCompInfoPopupChange('companyinfo',this.props.stockinfo.c+"  "+this.props.stockinfo.n,this.state.news.biz_summary,this.props.num); 
    }

    render() {
        return (
            <div className="RACorpInfoBox"> 
                <div className="detailTable">
                    <div className="stockinforow">
                        <div className="stockcode">{this.props.stockinfo.c}</div>
                        <div className="stockname"><a href={this.props.appId==="Hyper"?Config.hyperdomain+"/1004/"+this.props.stockinfo.ec+"/"+this.props.stockinfo.c :Config.domain+"/ETGate/?_ControlID=WPLETsiR001Control&_PageID=WPLETsiR001Idtl10&_DataStoreID=DSWPLETsiR001Control&_ActionID=stockDetail&stock_sec_code_mul=" + this.props.stockinfo.c + "&exchange_code="+this.props.stockinfo.ec+"&i_dom_flg=1&i_output_type=0&getFlg=on&OutSide=on&"} rel="noopener noreferrer" target={this.props.appId==="Hyper"?"_self":"_blank"}>{this.props.stockinfo.n}</a></div>
                        <div className="addto" onClick={this.handleAddTo(this.props.stockinfo.c,this.props.stockinfo.ec,this.props.stockinfo.rec)}>追加</div>
                        <div className="categorybox">{this.props.stockinfo.e}</div>
                        <div style={{clear: "both"}} />
                    </div>
                    { this.genDataRow() }
                </div>
            </div>
        )
    };
}